module.exports = {
	footerText: 'Copyright Metalinks C.A. © 2020',
}
